import { Box, Dialog, DialogContent } from '@mui/material'
import AIResponseLoadingGIF from '../../assets/loaders/loading-dark.gif';
import { convertToPixelFromVW } from '../../utils/ViewportUtils';

function DarkAdnocLoadingProgress({ size = 'small' }: { size: 'small' | 'large' | 'xlarge' }) {
  let height = convertToPixelFromVW(3);
  if (size === 'large') {
    height = height * 2;
  }
  if (size === 'xlarge') {
    height = height * 3;
  }

  return (
    <Dialog open={true}
      sx={{
        backgroundColor: 'rgba(255,255,255,15%)',
        backdropFilter: 'blur(2px)',
        '& .MuiPaper-root': {
          backgroundColor: 'transparent',
          boxShadow: 'none'
        }
      }}>
      <DialogContent>
        <Box sx={{
          width: '100%',
          height: height,
          display: 'grid',
          placeContent: 'center',
          justifyItems: 'center'
        }}>
          <img
            src={AIResponseLoadingGIF}
            alt='.'
            style={{
              width: height - 8,
              aspectRatio: 1 / 1
            }}></img>
        </Box>
      </DialogContent>
    </Dialog>
  )
}

export default DarkAdnocLoadingProgress